import { useEffect } from "react";
import { useTheme } from "@/utils/themeProvider";

export function useThemeShortcut() {
	const { theme, setTheme } = useTheme();

	useEffect(() => {
		function handleKeyDown(e: KeyboardEvent) {
			// Don't trigger when typing in inputs/textareas/contenteditable
			const target = e.target as HTMLElement;
			if (
				target.tagName === "INPUT" ||
				target.tagName === "TEXTAREA" ||
				target.tagName === "SELECT" ||
				target.isContentEditable
			) {
				return;
			}

			if (e.key === "d" && !e.metaKey && !e.ctrlKey && !e.altKey) {
				const css = document.createElement("style");
				css.appendChild(
					document.createTextNode(
						"*,*::before,*::after{transition:none!important}",
					),
				);
				document.head.appendChild(css);
				(() => window.getComputedStyle(document.body))();
				setTheme(theme === "dark" ? "light" : "dark");
				(() => window.getComputedStyle(document.body))();
				setTimeout(() => document.head.removeChild(css), 1);
			}
		}

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [theme, setTheme]);
}
